import { Component, Output, EventEmitter, AfterViewInit, ChangeDetectorRef } from '@angular/core';
import { environment } from '../../../../environments/environment';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'app-re-captcha-v2',
  templateUrl: './re-captcha-v2.component.html',
  styleUrls: ['./re-captcha-v2.component.scss'],
  standalone: false,
})
export class ReCaptchaV2Component implements AfterViewInit {
  // eslint-disable-next-line @angular-eslint/no-output-on-prefix
  @Output() onUpdateCaptchaToken: EventEmitter<string> =
    new EventEmitter<string>();

  siteKeyCaptchaV2: string = environment.recaptcha.siteKeyV2;
  captchaLoaded = false;
  captchaError: any = null;
  constructor(private cdr: ChangeDetectorRef) {}

  ngAfterViewInit() {
    this.waitForRecaptcha();
  }

  waitForRecaptcha() {
    const check = () => {
      if ((window as any).grecaptcha && (window as any).grecaptcha.render) {
        this.captchaLoaded = true;
        this.cdr.detectChanges();
      } else {
        setTimeout(check, 2000);
      }
    };
    check();
  }

  resolved(captchaResponse: string) {
    this.onUpdateCaptchaToken.emit(captchaResponse);
  }
}
